import { Link } from 'react-router-dom';
import {
	GovCard,
	GovFlex,
	GovGrid,
	GovGridItem,
	GovIcon,
} from '@gov-design-system-ce/react';
import { useLanguageNamespaceLoader, useLocale } from '@gov-nx/core/service';
import { useUsefulLinksContext } from '@gov-nx/module/page';
import { Breadcrumbs, Button, LayoutGap } from '@gov-nx/ui/web';
import { UsefulLinksSkeleton } from './UsefulLinksSkeleton';

export const UsefulLinksView = () => {
	const {
		code,
		data,
		numberOfLinks,
		numberOfLinksDisplayed,
		filterIncrementCount,
		isLoading,
		baseCmsUrlPath,
		showMore,
	} = useUsefulLinksContext();
	const { t } = useLocale(code);
	const translations = useLanguageNamespaceLoader(code);

	if (translations.isLoading) return null;

	return (
		<LayoutGap gap="l">
			<Breadcrumbs
				options={[
					{ label: t('domu'), toPage: 'dashboard' },
					{ label: t('uzitecne-odkazy') },
				]}
			/>
			<h1 className="mb-(--templates-margin-m)!">{t('uzitecne-odkazy')}</h1>
			<GovFlex
				direction="column"
				justifyContent="center"
				alignItems="center"
				gap="l">
				<GovGrid gap="l">
					{isLoading ? (
						<UsefulLinksSkeleton />
					) : (
						data.map((usefulLink) => (
							<GovGridItem
								column="12"
								columnMd="4"
								key={usefulLink.id}>
								<GovCard asChild>
									<Link
										to={usefulLink.link}
										target="_blank">
										<LayoutGap
											gap="s"
											className="h-full">
											<img
												src={baseCmsUrlPath + usefulLink.logo.file}
												alt={usefulLink.title + 'logo'}
												style={{
													height: '48px',
													width: 'min-content',
													objectFit: 'contain',
												}}
											/>
											<h3 className="text-headline-s!">{usefulLink.title}</h3>
											{usefulLink.description && (
												<p className="mt-0!">{usefulLink.description}</p>
											)}
											<div className="mt-auto!">
												<Button
													color="primary"
													type="solid"
													size="s"
													asChild
													isExpanded
													iconStart={
														<GovIcon
															type="components"
															name="box-arrow-up-right"
														/>
													}
													className="mt-(--templates-margin-s)! mb-(--templates-margin-s)!">
													<Link
														to={usefulLink.link}
														target="_blank">
														{t('akce.prejit-do-portalu')}
													</Link>
												</Button>
											</div>
										</LayoutGap>
									</Link>
								</GovCard>
							</GovGridItem>
						))
					)}
				</GovGrid>
				{numberOfLinks > numberOfLinksDisplayed ? (
					<Button
						onClick={showMore}
						color="primary"
						type="outlined"
						size="m">
						<span>
							{t('akce.nacist-dalsich', {
								count: filterIncrementCount,
							})}
						</span>
					</Button>
				) : null}
			</GovFlex>
		</LayoutGap>
	);
};
